import { render, staticRenderFns } from "./indicator-item-classification.vue?vue&type=template&id=632c9c7a&"
import script from "./indicator-item-classification.vue?vue&type=script&lang=js&"
export * from "./indicator-item-classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports